// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__8gle9","innerFooter":"styles_innerFooter__-y-tz","disclaimer":"styles_disclaimer__-Wuqd","footerBottom":"styles_footerBottom__WqbgT"};